import React from 'react';

export const BlueCheckmark = (): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <circle cx="15" cy="15" r="15" fill="#0544B5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8271 17.1464L18.7253 11.1176C19.0238 10.7502 19.5812 10.681 19.9702 10.9629C20.3592 11.2448 20.4326 11.7712 20.1341 12.1386L14.6112 18.9362C14.2817 19.3416 13.6482 19.3769 13.2707 19.0107L10.2967 16.1261C9.95458 15.7943 9.96207 15.2634 10.3134 14.9403C10.6647 14.6173 11.2268 14.6243 11.5689 14.9561L13.8271 17.1464Z"
      fill="white"
    />
  </svg>
);
